export const SITE = {
  name: "Slusariuc Costruzioni",
  phone: "+39 345 210 0498",
  phoneHref: "tel:+393452100498",
  email: "slusariuc.costruzioni@gmail.com",
  address: "Via dei Piani di Monte Savello 13",
  city: "00041 Albano Laziale (RM)",
  hours: [["Lun – Ven", "8:30 – 19:00"], ["Sabato", "Su appuntamento"]],
  vat: "17200271009",
  cf: "SLSCST01E14Z129H",
  rea: "RM-1702769",
  whatsapp:
    "https://wa.me/393452100498?text=" +
    encodeURIComponent("Buongiorno Slusariuc Costruzioni, vorrei informazioni per una ristrutturazione chiavi in mano."),
};

export const NAV = [
  ["Chi siamo", "chi-siamo"],
  ["Servizi", "servizi"],
  ["Forniture", "forniture"],
  ["Arredamento", "arredamento"],
  ["Metodo", "metodo"],
  ["Galleria", "galleria"],
  ["Contatti", "contatti"],
];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) {
    window.location.href = `/#${id}`;
    return;
  }
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70, duration: 1.6 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const EASE = [0.22, 1, 0.36, 1];
